import { FC } from 'react';
import { Box } from '@mui/material';

import { SupportMenuView } from './SupportMenu';
import { useSupportItems } from './hooks/useSupportItems';

export const SupportMenuContainer: FC = () => {
  const { menuItems } = useSupportItems();
  return (
    <Box
      sx={{
        display: 'flex',
        height: 42,
        width: 42,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <SupportMenuView menu={menuItems} />
    </Box>
  );
};
